import React from 'react';
import { FormGroup, FormControl, InputGroup, HelpBlock } from 'react-bootstrap';
import LabeledField from 'components/core/LabeledField';


const AddonInputGroupField = (props) => {

  const { input, type, placeholder, addon } = props;
  const { invalid, touched } = props.meta
  const hasError = (touched && invalid) ? 'error' : null;
  
  return (
    <FormGroup validationState={hasError}>
      <InputGroup>
        <FormControl
          {...input}
          type={type}
          placeholder={placeholder} />
        <InputGroup.Addon style={{'backgroundColor': '#eeeeee'}}>{addon}</InputGroup.Addon>
      </InputGroup>
    </FormGroup>
  )
}

const LabeledAddonInputGroupField = (props) => {
  return (
    <LabeledField {...props}>
      <AddonInputGroupField {...props} />
    </LabeledField>
  );
}

AddonInputGroupField.Labeled = LabeledAddonInputGroupField;

export default AddonInputGroupField;